import React from 'react';
import { InlineMath } from 'react-katex';
import 'katex/dist/katex.min.css';

interface MathTextProps {
    text: string;
    className?: string;
}

/**
 * Renders text that may contain inline LaTeX math enclosed in $...$ delimiters.
 * Non-math segments are rendered as plain text spans.
 * Example: "Find $\frac{c}{a}$ where $ax^2+bx+c=0$"
 */
const MathText: React.FC<MathTextProps> = ({ text, className }) => {
    if (!text) return null;

    // Split on $...$ inline math delimiters
    // Pattern: split on dollar-sign boundaries, keeping the math content
    const parts = text.split(/(\$[^$]+\$)/g);

    return (
        <span className={className}>
            {parts.map((part, index) => {
                if (part.startsWith('$') && part.endsWith('$') && part.length > 2) {
                    const mathContent = part.slice(1, -1);
                    try {
                        return <InlineMath key={index} math={mathContent} />;
                    } catch (e) {
                        // Fallback to raw text if KaTeX fails to parse
                        return <span key={index}>{part}</span>;
                    }
                }
                return <span key={index}>{part}</span>;
            })}
        </span>
    );
};

export default MathText;
